import React from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { NavItem } from "reactstrap";

import LoginButton from "./LoginButton";
import NewMapButton from "./NewMapButton";

class AuthNav extends React.Component {

    render() {

        if (this.props.user)
            return (
                <React.Fragment>
                    <NewMapButton />
                    <NavItem>
                        <button className="text-dark btn btn-link">{this.props.user.profile.name}</button>
                        </NavItem>
                </React.Fragment>
            );
        else
            return <LoginButton/>;
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.oidc.user
    };
};

export default connect(
    mapStateToProps,
    { push }
)(AuthNav);
